import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ParallaxProvider } from 'react-scroll-parallax';
import { BrowserRouter } from 'react-router-dom';
import AuthProvider from './global/context';
import { CookieConsentProvider } from './global/cookieConsent';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <CookieConsentProvider>
            <AuthProvider>
                <ParallaxProvider>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </ParallaxProvider>
            </AuthProvider>
        </CookieConsentProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
